import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./pages/Home/Home";
import Login from "./pages/Auth/Login/Login";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "./store";
import { getUserInfoByToken } from "./store/authSlice";
import protectUser from "./utils/loader/protectUser";
import { ShopeeLive } from "./pages/ShopeeLive";
import User from "./pages/Home/User";
import UserDetail from "./pages/Home/User/user-detail";
import ModManager from "./pages/Home/ModManager/mod-manager";
import TopUser from "./pages/Home/TopUser/TopUser";
import Order from "./pages/Home/Order/Order";
import Commission from "./pages/Home/Commission/Commission";
import DashBoard from "./pages/Home/Dashboard/DashBoard";
import AppGrowthPage from "./pages/Home/AppGrowth/app-growth-page";
import Bonus from "./pages/Home/Bonus/Bonus";
import BatchPayment from "./pages/Home/Payment/BatchPayment";
import BatchDetail from "./pages/Home/Payment/BatchDetail";
import Game from "./pages/Game/Game";
import GameDetail from "./pages/Game/GameDetail";
import GameCoin from "./pages/Home/GameCoin/GameCoin";
import PendingCoin from "./pages/Home/GameCoin/PendingCoin";
import VideoList from "./pages/Home/VideoList/VideoList";
import VoucherList from "./pages/Home/Voucher/VoucherList";
import VoucherForm from "./pages/Home/Voucher/VoucherForm";
import VoucherImport from "./pages/Home/Voucher/VoucherImport";
import VoucherStats from "./pages/Home/Voucher/VoucherStats";
import Referral from "./pages/Home/Referral";
import ReferredUsers from "./pages/Home/ReferredUsers";
import BannerList from "./pages/Home/Banner/BannerList";
import BannerForm from "./pages/Home/Banner/BannerForm";
import UtilityBlockList from "./pages/Home/UtilityBlock/UtilityBlockList";
import UtilityBlockForm from "./pages/Home/UtilityBlock/UtilityBlockForm";
import LandingPageList from "./pages/Home/LandingPage/LandingPageList";
import LandingPageForm from "./pages/Home/LandingPage/LandingPageForm";
import GuideVideoConfig from "./pages/Home/GuideVideo/GuideVideoConfig";
import AppVersionGateConfig from "./pages/Home/AppVersionGate/AppVersionGateConfig";
import TikTokAffiliateConfig from "./pages/Home/TikTokAffiliateConfig/TikTokAffiliateConfig";
import ProductNotes from "./pages/Home/ProductNotes/ProductNotes";
import EmailCampaignList from "./pages/Home/Email/EmailCampaignList";
import EmailCampaignForm from "./pages/Home/Email/EmailCampaignForm";
import EmailCampaignDetail from "./pages/Home/Email/EmailCampaignDetail";
import PushBroadcastList from "./pages/Home/Push/push-broadcast-list";
import PushBroadcastForm from "./pages/Home/Push/push-broadcast-form";
import PushBroadcastDetail from "./pages/Home/Push/push-broadcast-detail";
import PushTemplateManager from "./pages/Home/Push/push-template-manager";
import Withdraw from "./pages/Home/Withdraw/Withdraw";
import WithdrawDetail from "./pages/Home/Withdraw/PaymentDetail";
import PostList from "./pages/Home/Post/post-list";
import CommentList from "./pages/Home/Comment/comment-list";
import LogViewer from "./pages/Home/LogViewer/log-viewer";
import PromoList from "./pages/Home/Promo/PromoList";
import PromoForm from "./pages/Home/Promo/PromoForm";
import RewardProgramList from "./pages/Home/RewardProgram/reward-program-list";
import RewardProgramForm from "./pages/Home/RewardProgram/reward-program-form";
import RewardProgramDetail from "./pages/Home/RewardProgram/reward-program-detail";
import XuProgramSettingsPage from "./pages/Home/XuProgram/xu-program-settings-page";
import CommunityPostList from "./pages/Home/Community/community-post-list";
function App() {
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        dispatch(getUserInfoByToken());
    }, [dispatch]);
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Home />,
            loader: protectUser,
            children: [
                {
                    path: "/user",
                    element: <User />,
                },
                {
                    // Chi tiết 1 thành viên (thay php admin dashboard-user.php)
                    path: "/user/:userId",
                    element: <UserDetail />,
                },
                {
                    path: "/topuser",
                    element: <TopUser />,
                },
                {
                    path: "/mods",
                    element: <ModManager />,
                },
                {
                    path: "/order",
                    element: <Order />,
                },
                {
                    path: "/commission",
                    element: <Commission />,
                },
                {
                    path: "/bonus",
                    element: <Bonus />,
                },
                {
                    index: true,
                    path: "/dashboard",
                    element: <DashBoard />,
                },
                {
                    path: "app-growth",
                    element: <AppGrowthPage />,
                },
                {
                    path: "payment/batch",
                    element: <BatchPayment />,
                },
                {
                    path: "payment/batch/:id",
                    element: <BatchDetail />,
                },
                {
                    path: "gamecoin",
                    element: <GameCoin />,
                },
                {
                    path: "pendingcoin",
                    element: <PendingCoin />,
                },
                {
                    path: "videolist",
                    element: <VideoList />,
                },
                {
                    path: "voucher",
                    element: <VoucherList />,
                },
                {
                    path: "voucher/create",
                    element: <VoucherForm />,
                },
                {
                    path: "voucher/:id/edit",
                    element: <VoucherForm />,
                },
                {
                    path: "voucher/import",
                    element: <VoucherImport />,
                },
                {
                    path: "voucher/stats",
                    element: <VoucherStats />,
                },
                {
                    path: "referral",
                    element: <Referral />,
                },
                {
                    path: "referred-users",
                    element: <ReferredUsers />,
                },
                {
                    path: "banner",
                    element: <BannerList />,
                },
                {
                    path: "banner/create",
                    element: <BannerForm />,
                },
                {
                    path: "banner/:id/edit",
                    element: <BannerForm />,
                },
                {
                    path: "page",
                    element: <LandingPageList />,
                },
                {
                    path: "page/create",
                    element: <LandingPageForm />,
                },
                {
                    path: "page/:id/edit",
                    element: <LandingPageForm />,
                },
                {
                    path: "utility-block",
                    element: <UtilityBlockList />,
                },
                {
                    path: "utility-block/create",
                    element: <UtilityBlockForm />,
                },
                {
                    path: "utility-block/:id/edit",
                    element: <UtilityBlockForm />,
                },
                {
                    path: "guide-video",
                    element: <GuideVideoConfig />,
                },
                {
                    path: "app-version-gate",
                    element: <AppVersionGateConfig />,
                },
                {
                    path: "tiktok-affiliate-config",
                    element: <TikTokAffiliateConfig />,
                },
                {
                    path: "product-notes",
                    element: <ProductNotes />,
                },
                {
                    path: "email",
                    element: <EmailCampaignList />,
                },
                {
                    path: "email/create",
                    element: <EmailCampaignForm />,
                },
                {
                    path: "email/:id",
                    element: <EmailCampaignDetail />,
                },
                {
                    path: "email/:id/edit",
                    element: <EmailCampaignForm />,
                },
                {
                    path: "push",
                    element: <PushBroadcastList />,
                },
                {
                    path: "push/new",
                    element: <PushBroadcastForm />,
                },
                {
                    path: "push/templates",
                    element: <PushTemplateManager />,
                },
                {
                    path: "push/:id",
                    element: <PushBroadcastDetail />,
                },
                {
                    path: "withdraw",
                    element: <Withdraw />,
                },
                {
                    path: "withdraw/:id",
                    element: <WithdrawDetail />,
                },
                {
                    path: "post",
                    element: <PostList />,
                },
                {
                    path: "comment",
                    element: <CommentList />,
                },
                {
                    path: "community",
                    element: <CommunityPostList />,
                },
                {
                    path: "logs",
                    element: <LogViewer />,
                },
                {
                    path: "app-rate-promo",
                    element: <PromoList />,
                },
                {
                    path: "app-rate-promo/create",
                    element: <PromoForm />,
                },
                {
                    path: "app-rate-promo/:id/edit",
                    element: <PromoForm />,
                },
                {
                    path: "reward-program",
                    element: <RewardProgramList />,
                },
                {
                    path: "xu-program",
                    element: <XuProgramSettingsPage />,
                },
                {
                    path: "reward-program/create",
                    element: <RewardProgramForm />,
                },
                {
                    path: "reward-program/:id/edit",
                    element: <RewardProgramForm />,
                },
                {
                    path: "reward-program/:id",
                    element: <RewardProgramDetail />,
                },
            ],
        },
        {
            path: "/login",
            element: <Login />,
        },
        {
            path: "/shopeelive",
            element: <ShopeeLive />,
        },
        {
            path: "/game_manager",
            element: <Game />,
        },
        {
            path: "/game_manager/:gameId",
            element: <GameDetail />,
        },
    ]);
    return <RouterProvider router={router} />;
}

export default App;
